<template>
<div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="80">
        <v-img src="@/assets/images/NEOCenter.png" max-width="150" />
        <h2 class="pl-2 hidden-sm-and-down">
            Booking<span v-if="user && user.roles != 'User'" class="pl-2">
                <span>({{ user.roles }})</span>
            </span>
        </h2>

        <v-spacer />

        <div>
            <v-tabs class="hidden-sm-and-down" optional>
                <v-tab v-for="(name, i) in items" :key="i" :to="{ name }" :exact="name === 'Forside'" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>{{ name }}</v-tab>
                <v-tab v-if="!$auth.loading && !$auth.isAuthenticated" @click="login" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>Log ind</v-tab>
                <v-tab v-if="$auth.isAuthenticated" to="/profile" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>Profil</v-tab>
                <v-tab v-if="!$auth.loading && $auth.isAuthenticated" @click="logout" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>Log ud</v-tab>
            </v-tabs>
        </div>
        <img v-if="$auth.isAuthenticated" width="32" to="/profile" :src="$auth.user.picture" />

        <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
    </v-app-bar>

    <!-- <home-drawer v-model="drawer" :items="items" /> -->

    <v-navigation-drawer v-model="drawer" absolute top temporary overlay-color="secondary" overlay-opacity=".8" class="hidden-md-and-up">
        <v-list nav dense>
            <v-list-item-group active-class="deep-purple--text text--accent-4">
                <v-list-item v-for="(name, i) in items" :key="i" :to="{ name }" :exact="name === 'Forside'" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>
                    <v-list-item-title>{{ name }}</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="!$auth.loading && !$auth.isAuthenticated" @click="login" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>
                    <v-list-item-title>Log ind</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="$auth.isAuthenticated" to="/profile" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>
                    <v-list-item-title>Profil</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!$auth.loading && $auth.isAuthenticated" @click="logout" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>
                    <v-list-item-title>Log ud</v-list-item-title>
                </v-list-item>

            </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</div>
</template>

<script>
import core from "./../../mixins/core";
import store from "./../../store";
import {
    EventBus
} from "./../../event-bus";

export default {
    name: "HomeAppBar",
    mixins: [core],
    components: {
        //   HomeDrawer: () => import("./Drawer"),
    },

    methods: {
        // Log the user in
        login() {
            this.$auth.loginWithRedirect();
        },
        updateUser() {
            this.user = store.getters.currentUser;
        },
        // Log the user out
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });
        },
        updateMenu() {
            if (this.user.roles == "Admin") {
                this.items = ["Forside", "Kalender", "Admin", "Centers", "Users"];
            }
            if (this.user.roles == "CenterAdmin") {
                this.items = ["Forside", "Kalender", "CenterAdmin"];
            }
        },
    },
    created() {
        EventBus.$on("updateUser", this.updateUser);

        this.$store.subscribe((mutation, state) => {
            if (mutation.type === "setUser") {
                this.user = state.currentUser;
                this.updateMenu();
            }
        });
    },

    mounted() {
        if (this.$auth.isAuthenticated) {
            console.log(this.$auth.user);
        }
    },
    data: () => ({
        user: null,
        drawer: null,
        items: [
            "Forside",
            "Kalender",
            //"Shop",
            //    'Kontakt',
            //'Pro',
        ],
    }),
};
</script>
